export type AnimalSearchPhase =
  | "error"
  | "loading"
  | "prompt"
  | "empty"
  | "results";

/**
 * Fehler ersetzt die Liste nur, solange noch nichts da ist.
 * Vorhandene Fälle bleiben sichtbar; der Hinweis kommt extra.
 */
export function animalSearchPhase(input: {
  hasError: boolean;
  loading: boolean;
  caseCount: number;
  query: string;
  resultCount: number;
}): AnimalSearchPhase {
  if (input.hasError && input.caseCount === 0) return "error";
  if (input.loading && input.caseCount === 0) return "loading";
  if (!input.query) return "prompt";
  if (input.resultCount === 0) return "empty";
  return "results";
}

export function showSearchErrorHint(input: {
  hasError: boolean;
  caseCount: number;
}): boolean {
  return input.hasError && input.caseCount > 0;
}
